/**
 * ZEmptyState — Zephyr OS Design System
 *
 * Empty state with app mark icon, message, hint, and optional ghost button.
 * Spec: design-system.md Section 7 (Empty States).
 */

import ZButton from './ZButton';

export default function ZEmptyState({
  mark = 'Z',
  accent = '#6B35B8',
  message = 'Nothing here yet',
  hint = '',
  onAction,
  actionLabel = '',
}) {
  return (
    <div style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      padding: '48px 16px',
      gap: 12,
    }}>
      {/* App mark at reduced size with faded accent background */}
      <div style={{
        width: 32,
        height: 32,
        borderRadius: 10,
        background: `${accent}26`, // ~15% opacity
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}>
        <span style={{
          fontFamily: "'Playfair Display', Georgia, serif",
          fontStyle: 'italic',
          fontWeight: 300,
          fontSize: 16,
          color: '#ffffff',
          opacity: 0.6,
        }}>
          {mark}
        </span>
      </div>

      {/* Primary message */}
      <p style={{
        fontSize: 12,
        fontFamily: "'Inter', -apple-system, sans-serif",
        fontFeatureSettings: '"cv01", "ss03"',
        fontWeight: 400,
        color: '#6b7084',
        textAlign: 'center',
        margin: 0,
      }}>
        {message}
      </p>

      {/* Secondary hint */}
      {hint && (
        <p style={{
          fontSize: 10,
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontFeatureSettings: '"cv01", "ss03"',
          fontWeight: 400,
          color: '#454860',
          textAlign: 'center',
          margin: 0,
        }}>
          {hint}
        </p>
      )}

      {/* Optional action button (ghost style) */}
      {onAction && actionLabel && (
        <ZButton variant="secondary" onClick={onAction} style={{ marginTop: 8 }}>
          {actionLabel}
        </ZButton>
      )}
    </div>
  );
}
